import PropTypes from 'prop-types';
import { SHAREHOLDER_LEGEND_ITEMS, SHAREHOLDER_LEGEND_KINDS } from './shareholderGraphUtils';

/** The marker of one legend row, drawn like the element it explains in the graph. */
const LegendMarker = ({ item }) => {
  switch (item.kind) {
    case SHAREHOLDER_LEGEND_KINDS.ULTIMATE:
      return (
        <div className="icon-wrap beneficial">
          <img src={item.icon} alt="" aria-hidden="true" />
        </div>
      );
    case SHAREHOLDER_LEGEND_KINDS.CHIP:
      return (
        <div className="icon-wrap legend-swatch">
          <span className="legend-chip">{item.sample}</span>
        </div>
      );
    case SHAREHOLDER_LEGEND_KINDS.DASHED:
      return (
        <div className="icon-wrap legend-swatch">
          <span className="legend-dashed" />
        </div>
      );
    case SHAREHOLDER_LEGEND_KINDS.FIGURE:
      return (
        <div className="icon-wrap legend-swatch">
          <span className="legend-figure">
            {item.sample}
            <span className="legend-figure-year">&lsquo;{item.sampleYear}</span>
          </span>
        </div>
      );
    default:
      return (
        <div className="icon-wrap">
          <img src={item.icon} alt="" aria-hidden="true" />
        </div>
      );
  }
};

LegendMarker.propTypes = {
  item: PropTypes.shape({
    kind: PropTypes.oneOf(Object.values(SHAREHOLDER_LEGEND_KINDS)).isRequired,
    icon: PropTypes.string,
    sample: PropTypes.string,
    sampleYear: PropTypes.string
  }).isRequired
};

/**
 * ShareholderLegend - legend of the card-based shareholder graph (8 items, mockup order):
 * Target, Organization, Individual, Subsidiary, Ultimate owner, Direct share, Aggregated below
 * filter, Self-disclosed figure.
 *
 * @param {Object} props
 * @param {string} props.variant - 'mini' (tab view, no title) or 'popup' (full-screen, with title)
 */
const ShareholderLegend = ({ variant }) => {
  const isPopup = variant === 'popup';

  return (
    <div className="legend">
      {isPopup && <div className="legend-title">Legend</div>}
      {SHAREHOLDER_LEGEND_ITEMS.map((item) => (
        <div className={`legend-row legend-row--${item.kind}`} key={item.key}>
          <LegendMarker item={item} />
          <div>{item.label}</div>
        </div>
      ))}
    </div>
  );
};

ShareholderLegend.propTypes = {
  variant: PropTypes.oneOf(['mini', 'popup'])
};

export default ShareholderLegend;
